import { useRouteMatch } from 'react-router'

function useRetailerAccountSlugFromRoute() {
  const match = useRouteMatch()

  const retailerAccountSlug =
    'retailerAccountSlug' in match.params &&
    typeof match.params.retailerAccountSlug === 'string'
      ? match.params.retailerAccountSlug
      : undefined

  return retailerAccountSlug
}

export default useRetailerAccountSlugFromRoute
